/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import {useIntl} from 'react-intl'

import {BIRTHDAY_MONTHS} from '../../constants'

export default function useEmailSignupFields({
    form: {
        control,
        formState: {errors}
    },
    prefix = ''
}) {
    const {formatMessage} = useIntl()
    const fields = {
        email: {
            name: `${prefix}email`,
            label: formatMessage({
                defaultMessage: 'Email',
                id: 'use_email_signup_fields.label.email'
            }),
            placeholder: 'you@email.com',
            defaultValue: '',
            type: 'email',
            autoComplete: 'email',
            rules: {
                required: formatMessage({
                    defaultMessage: 'Please enter your email address.',
                    id: 'use_email_signup_fields.error.required_email'
                }),
                pattern: {
                    /* eslint-disable no-useless-escape */
                    value: /^[\w.%+\-]+@[\w.\-]+\.[\w]{2,6}$/,
                    message: formatMessage({
                        defaultMessage: 'Please match the requested format.',
                        id: 'use_email_signup_fields.error.pattern_email'
                    })
                }
            },
            error: errors?.[`${prefix}email`],
            control
        },
        birthDayMonth: {
            name: `${prefix}birthdayMonth`,
            label: '',
            placeholder: 'Birthday Month',
            options: BIRTHDAY_MONTHS,
            defaultValue: '',
            type: 'select',
            rules: {
                required: formatMessage({
                    defaultMessage: 'Please select your birthday month.',
                    id: 'use_email_signup_fields.error.required_birthdayMonth'
                })
            },
            error: errors?.[`${prefix}birthdayMonth`],
            control
        }
    }
    return fields
}
